var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapClasses },
    [
      _vm.type !== "textarea"
        ? [
            _vm.prepend
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.slotReady,
                        expression: "slotReady"
                      }
                    ],
                    class: [_vm.prefixCls + "-group-prepend"]
                  },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.clearable && _vm.currentValue && !_vm.itemDisabled
              ? _c("i", {
                  staticClass: "ivu-icon",
                  class: [
                    "ivu-icon-ios-close-circle",
                    _vm.prefixCls + "-icon",
                    _vm.prefixCls + "-icon-clear",
                    _vm.prefixCls + "-icon-normal"
                  ],
                  style: _vm.clearableStyles,
                  on: { click: _vm.handleClear }
                })
              : _vm.icon
              ? _c("i", {
                  staticClass: "ivu-icon",
                  class: [
                    "ivu-icon-" + _vm.icon,
                    _vm.prefixCls + "-icon",
                    _vm.prefixCls + "-icon-normal"
                  ],
                  on: { click: _vm.handleIconClick }
                })
              : _vm.search && _vm.enterButton === false
              ? _c("i", {
                  staticClass: "ivu-icon ivu-icon-ios-search",
                  class: [
                    _vm.prefixCls + "-icon",
                    _vm.prefixCls + "-icon-normal",
                    _vm.prefixCls + "-search-icon"
                  ],
                  on: { click: _vm.handleSearch }
                })
              : _vm.showSuffix
              ? _c(
                  "span",
                  { staticClass: "ivu-input-suffix" },
                  [
                    _vm._t("suffix", function() {
                      return [
                        _vm.suffix
                          ? _c("i", {
                              staticClass: "ivu-icon",
                              class: ["ivu-icon-" + _vm.suffix]
                            })
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              : _vm.showWordLimit
              ? _c("span", { staticClass: "ivu-input-word-count" }, [
                  _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
                ])
              : _vm.password
              ? _c(
                  "span",
                  {
                    staticClass: "ivu-input-suffix",
                    on: { click: _vm.handleToggleShowPassword }
                  },
                  [
                    _vm.showPassword
                      ? _c("i", {
                          staticClass: "ivu-icon ivu-icon-ios-eye-outline"
                        })
                      : _c("i", {
                          staticClass: "ivu-icon ivu-icon-ios-eye-off-outline"
                        })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              !_vm.icon
                ? _c("i", {
                    staticClass: "ivu-icon ivu-icon-ios-loading ivu-load-loop",
                    class: [
                      _vm.prefixCls + "-icon",
                      _vm.prefixCls + "-icon-validate"
                    ]
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("input", {
              ref: "input",
              class: _vm.inputClasses,
              attrs: {
                id: _vm.elementId,
                autocomplete: _vm.autocomplete,
                spellcheck: _vm.spellcheck,
                type: _vm.currentType,
                placeholder: _vm.placeholder,
                disabled: _vm.itemDisabled,
                maxlength: _vm.maxlength,
                readonly: _vm.readonly,
                name: _vm.name,
                number: _vm.number,
                autofocus: _vm.autofocus
              },
              domProps: { value: _vm.currentValue },
              on: {
                keyup: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleEnter.apply(null, arguments)
                  },
                  _vm.handleKeyup
                ],
                keypress: _vm.handleKeypress,
                keydown: _vm.handleKeydown,
                focus: _vm.handleFocus,
                blur: _vm.handleBlur,
                compositionstart: _vm.handleComposition,
                compositionupdate: _vm.handleComposition,
                compositionend: _vm.handleComposition,
                input: _vm.handleInput,
                change: _vm.handleChange
              }
            }),
            _vm._v(" "),
            _vm.append
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.slotReady,
                        expression: "slotReady"
                      }
                    ],
                    class: [_vm.prefixCls + "-group-append"]
                  },
                  [_vm._t("append")],
                  2
                )
              : _vm.search && _vm.enterButton
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.prefixCls + "-group-append",
                      _vm.prefixCls + "-search"
                    ],
                    on: { click: _vm.handleSearch }
                  },
                  [
                    _vm.enterButton === true
                      ? _c("i", { staticClass: "ivu-icon ivu-icon-ios-search" })
                      : [_vm._v(_vm._s(_vm.enterButton))]
                  ],
                  2
                )
              : _vm.showPrefix
              ? _c(
                  "span",
                  { staticClass: "ivu-input-prefix" },
                  [
                    _vm._t("prefix", function() {
                      return [
                        _vm.prefix
                          ? _c("i", {
                              staticClass: "ivu-icon",
                              class: ["ivu-icon-" + _vm.prefix]
                            })
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : [
            _c("textarea", {
              ref: "textarea",
              class: _vm.textareaClasses,
              style: _vm.textareaStyles,
              attrs: {
                id: _vm.elementId,
                wrap: _vm.wrap,
                autocomplete: _vm.autocomplete,
                spellcheck: _vm.spellcheck,
                placeholder: _vm.placeholder,
                disabled: _vm.itemDisabled,
                rows: _vm.rows,
                maxlength: _vm.maxlength,
                readonly: _vm.readonly,
                name: _vm.name,
                autofocus: _vm.autofocus
              },
              domProps: { value: _vm.currentValue },
              on: {
                keyup: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleEnter.apply(null, arguments)
                  },
                  _vm.handleKeyup
                ],
                keypress: _vm.handleKeypress,
                keydown: _vm.handleKeydown,
                focus: _vm.handleFocus,
                blur: _vm.handleBlur,
                compositionstart: _vm.handleComposition,
                compositionupdate: _vm.handleComposition,
                compositionend: _vm.handleComposition,
                input: _vm.handleInput
              }
            }),
            _vm._v(" "),
            _vm.showWordLimit
              ? _c("span", { staticClass: "ivu-input-word-count" }, [
                  _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
                ])
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49c1831b", { render: render, staticRenderFns: staticRenderFns })
  }
}